<template src="./CompanyServices.html"></template>

<script>
import {
  getCompany,
  getServices,
  getServiceByCompany,
  createServiceByCompany,
  updateGroupByCompany
} from '../../../services'
import Service from '../../../components/Service/Service'
import { isNumber, calcANS } from '../../../utils'
import { required, minValue } from 'vuelidate/lib/validators'

export default {
  name: 'CompanyServices',
  components: {
    Service
  },
  data: () => ({
    company: {},
    services: [],
    servicesByCompany: [],
    groupServicesByCompany: [],
    // Dialog states
    showNewServiceDialog: false,
    showNewGroupDialog: false,
    showManageDialog: false,
    // New service form
    selectService: {},
    newService: {},
    // New group form
    nameGroup: '',
    totalGroup: 0,
    costGroup: 0,
    statusGroup: 'HIDDEN',
    newServices: [],
    // Manage group dialog
    managedGroup: [],
    group: {
      id: '',
      name: '',
      total: 0,
      cost: 0,
      ans: 0,
      status: 'HIDDEN'
    },
    statusOptions: [
      { text: 'Visible', value: 'VISIBLE' },
      { text: 'Oculto', value: 'HIDDEN' },
      { text: 'Borrador', value: 'DRAFT' }
    ]
  }),
  validations () {
    const newService = {
      ans: { required },
      value: { required, minValue: minValue(this.selectService.cost) }
    }
    const newServices = {
      required,
      $each: {
        listServices: { id: { required } },
        ans: { required },
        order: { required },
        value: {
          required,
          minValue: (value, item) => value >= item.listServices.cost
        }
      }
    }

    if (this.showNewServiceDialog) {
      return { newService }
    }
    if (this.showNewGroupDialog) {
      return {
        nameGroup: { required },
        totalGroup: { required, minValue: minValue(this.costGroup) },
        newServices
      }
    }
    return {}
  },
  created () {
    this.getCompanyInfo()
    this.getCompanyServices()
    this.listServices()
    this.newServices.push({ listServices: this.services })
  },
  computed: {
    draftGroups () {
      return this.groupServicesByCompany.filter(g => g[0] && g[0].status === 'DRAFT')
    },
    activeGroups () {
      return this.groupServicesByCompany
        .filter(g => g[0] && g[0].status !== 'DRAFT')
        .sort((a, b) => {
          if (a[0].status === 'VISIBLE' && b[0].status !== 'VISIBLE') return -1
          if (a[0].status !== 'VISIBLE' && b[0].status === 'VISIBLE') return 1
          return 0
        })
    },
    groupCost () {
      const total = this.newServices.reduce((acc, service) => {
        acc += service.listServices.cost || 0
        return acc
      }, 0)
      this.costGroup = total
      return total
    },
    groupANSTotal () {
      return calcANS(this.newServices)
    },
    managedGroupCost () {
      return this.managedGroup.reduce((sum, g) => sum + (g.service?.cost || 0), 0)
    },
    managedGroupANS () {
      return calcANS(this.managedGroup)
    }
  },
  methods: {
    async getCompanyInfo () {
      try {
        this.company = await getCompany(this.$route.params.id)
      } catch (err) {
        console.error('Error on get company:', err)
      }
    },
    async getCompanyServices () {
      try {
        const [servicesByCompany, ...groupServicesByCompany] = await getServiceByCompany(
          this.$route.params.id
        )
        this.servicesByCompany = servicesByCompany || []
        this.groupServicesByCompany = groupServicesByCompany || []
      } catch (err) {
        console.error('Error on list company services:', err)
      }
    },
    async listServices () {
      try {
        this.services = await getServices()
      } catch (err) {
        console.error('Error on list services:', err)
      }
    },
    async createOneService () {
      try {
        await createServiceByCompany({
          isGroup: false,
          companyId: this.$route.params.id,
          service: {
            serviceId: this.selectService.id,
            value: this.newService.value,
            ans: this.newService.ans
          }
        })
        this.$swal({ text: 'Se agregó el servicio.', buttons: false, icon: 'success', timer: 3000 })
        this.closeNewServiceDialog()
        await this.getCompanyServices()
      } catch (err) {
        console.error('Create service by company:', err)
        this.$swal({ text: 'Ocurrió un error, intenta más tarde.', buttons: false, icon: 'error', timer: 3000 })
      }
    },
    async createGroup () {
      try {
        const services = this.newServices.map((service) => ({
          serviceId: service.listServices.id,
          value: service.value,
          ans: service.ans,
          order: service.order
        }))
        await createServiceByCompany({
          isGroup: true,
          companyId: this.$route.params.id,
          name: this.nameGroup,
          total: this.totalGroup,
          status: this.statusGroup,
          services
        })
        this.$swal({ text: 'Se agregó el grupo de servicios.', buttons: false, icon: 'success', timer: 3000 })
        this.closeNewGroupDialog()
        await this.getCompanyServices()
      } catch (err) {
        console.error('Create group by company:', err)
        this.$swal({ text: 'Ocurrió un error, intenta más tarde.', buttons: false, icon: 'error', timer: 3000 })
      }
    },
    async updateGroup () {
      try {
        await updateGroupByCompany(this.group.id, {
          total: this.group.total,
          name: this.group.name,
          status: this.group.status
        })
        this.$swal({ text: 'Se actualizó el grupo de servicios.', buttons: false, icon: 'success', timer: 3000 })
        this.showManageDialog = false
        await this.getCompanyServices()
      } catch (err) {
        console.error('ERROR on update group =>', err)
        this.$swal({ text: 'Ocurrió un error, intenta más tarde.', buttons: false, icon: 'error', timer: 3000 })
      }
    },
    openManageDialog (groupService) {
      this.group.id = groupService[0].groupId
      this.group.name = groupService[0].name.replace('[Borrador] ', '')
      this.group.total = groupService[0].total
      this.group.cost = groupService.reduce((sum, g) => (sum += g.service.cost), 0)
      this.group.ans = calcANS(groupService)
      this.group.status = groupService[0].status
      this.managedGroup = groupService
      this.showManageDialog = true
    },
    async refreshManageDialog () {
      await this.getCompanyServices()
      const groupId = this.group.id
      const updated = this.groupServicesByCompany.find(g => g.length > 0 && g[0].groupId === groupId)
      if (updated) {
        this.managedGroup = updated
        this.group.cost = updated.reduce((sum, g) => (sum += g.service.cost), 0)
        this.group.ans = calcANS(updated)
      }
    },
    closeNewServiceDialog () {
      this.showNewServiceDialog = false
      this.selectService = {}
      this.newService = {}
    },
    closeNewGroupDialog () {
      this.showNewGroupDialog = false
      this.nameGroup = ''
      this.totalGroup = 0
      this.statusGroup = 'HIDDEN'
      this.newServices = [{ listServices: this.services }]
    },
    isNumber,
    calcANS,
    addService () {
      this.newServices.push({ listServices: this.services })
    },
    removeService (index) {
      this.newServices = this.newServices.filter((_, i) => i !== index)
    }
  }
}
</script>
<style lang="scss" src="./CompanyServices.scss" scoped></style>
